import '@splidejs/splide/dist/css/splide.min.css';

import Splide from '@splidejs/splide';

const AppLauncherList = () => {
  const CONFIG_SPLIDE = {
    autoWidth: true,
    autoHeight: true,
    drag: false,
    arrows: false,
    pagination: false,
    breakpoints: {
      1024: {
        perPage: 1,
        pagination: false,
        gap: '1rem',
        drag: true
      }
    }
  };

  const appLauncherList = document.querySelector('.AppLauncherList');

  if (appLauncherList) {
    new Splide(appLauncherList, CONFIG_SPLIDE).mount();
  }
};

export default AppLauncherList;
